// Web entry point — delegates to the shared base implementation.
// Refresh tokens on web are managed internally by oidc-client-ts (sessionStorage).
// Platform-specific encryption is handled by secureStorage.web.ts (AES-GCM / IndexedDB).
export { storageService } from './storageService.base';